var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f73a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174461"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 215.437,
    x2: 294.563,
    xlinkHref: "#lg1",
    y1: 419.694,
    y2: 419.694
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 460.856,
    y2: 493.99
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#092a40",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#092a40"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.709,
    x2: 253.709,
    xlinkHref: "#lg2",
    y1: 444.675,
    y2: 380.675
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.817,
    x2: 396.849,
    xlinkHref: "#lg1",
    y1: 95.144,
    y2: 364.175
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.111,
    x2: 287.611,
    xlinkHref: "#lg2",
    y1: 191.796,
    y2: 163.796
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.97,
    x2: 374.372,
    y1: 115.297,
    y2: 341.699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 399,
    x2: 335.498,
    xlinkHref: "#lg3",
    y1: 222.327,
    y2: 222.327
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 356.124,
    y2: 401.327
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.333,
    x2: 249.968,
    xlinkHref: "#lg3",
    y1: 252.464,
    y2: 252.464
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.333,
    x2: 433.968,
    xlinkHref: "#lg3",
    y1: 288.37,
    y2: 288.37
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.446,
    x2: 273.34,
    y1: 208.069,
    y2: 304.964
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.067,
    x2: 387.451,
    y1: 124.986,
    y2: 263.37
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.255,
    x2: 445.164,
    y1: 256.103,
    y2: 329.011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m215.437 367.33h79.125v104.729h-79.125z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.76 504.354h-183.52c-13.224 0-23.944-10.72-23.944-23.944 0-13.224 10.72-23.944 23.944-23.944h183.52c13.224 0 23.944 10.72 23.944 23.944 0 13.223-10.72 23.944-23.944 23.944z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.437 401.202 70.856 70.856h8.27v-104.728h-79.126z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m471.896 401.202h-433.792c-21.044 0-38.104-17.059-38.104-38.103v-281.544c0-21.044 17.06-38.104 38.104-38.104h433.793c21.044 0 38.104 17.06 38.104 38.104v281.544c-.001 21.044-17.061 38.103-38.105 38.103z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.259 43.451 57.733 57.733v266.145h-57.733z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.14 367.329h-376.28c-17.599 0-31.866-14.267-31.866-31.866v-226.273c0-17.599 14.267-31.866 31.866-31.866h376.28c17.599 0 31.866 14.267 31.866 31.866v226.273c0 17.6-14.267 31.866-31.866 31.866z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.132 77.324h-33.873v290.005h57.733v-266.145z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 330.993v32.105c0 21.044 17.06 38.104 38.104 38.104h433.793c21.044 0 38.104-17.06 38.104-38.104v-32.105z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m252.962 137.598 31.749 31.749v197.982h-31.749z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.962 209.411 31.749 31.749v102.229c0 13.222-10.718 23.94-23.94 23.94h-7.809z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m257.024 367.329h-69.544v-221.366c0-7.388 5.989-13.378 13.378-13.378h42.789c7.388 0 13.378 5.989 13.378 13.378v221.366z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.259 367.329h-69.544v-348.305c0-7.388 5.989-13.378 13.378-13.378h42.789c7.388 0 13.378 5.989 13.378 13.378v348.305z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.494 367.329h-69.544v-147.979c0-7.388 5.989-13.378 13.378-13.378h42.789c7.388 0 13.378 5.989 13.378 13.378v147.979z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#7acbff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.875 161.114h-32.34c-2.945 0-5.332-2.387-5.332-5.332v-14.554c0-2.945 2.387-5.332 5.332-5.332h32.34c2.945 0 5.332 2.387 5.332 5.332v14.554c0 2.945-2.387 5.332-5.332 5.332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.385 161.114h-57.687c-2.945 0-5.332-2.387-5.332-5.332v-14.554c0-2.945 2.387-5.332 5.332-5.332h57.687c2.945 0 5.332 2.387 5.332 5.332v14.554c0 2.945-2.387 5.332-5.332 5.332z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#7acbff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m137.045 199.097h32.34c2.945 0 5.332-2.387 5.332-5.332v-14.554c0-2.945-2.387-5.332-5.332-5.332h-32.34c-2.945 0-5.332 2.387-5.332 5.332v14.554c0 2.945 2.388 5.332 5.332 5.332z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.535 199.097h57.687c2.945 0 5.332-2.387 5.332-5.332v-14.554c0-2.945-2.387-5.332-5.332-5.332h-57.687c-2.945 0-5.332 2.387-5.332 5.332v14.554c0 2.945 2.388 5.332 5.332 5.332z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m90.875 237.08h-32.34c-2.945 0-5.332-2.387-5.332-5.332v-14.554c0-2.945 2.387-5.332 5.332-5.332h32.34c2.945 0 5.332 2.387 5.332 5.332v14.554c0 2.945-2.387 5.332-5.332 5.332z",
    fill: "#7acbff"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharts);
export default __webpack_public_path__ + "static/media/charts.7ce1e695d07e4ebf3fd0949b7cb3d538.svg";
export { ForwardRef as ReactComponent };